import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { createRef, useContext, useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
import { math } from "noood/util/math/math";
import SpinnerApple from "noood/comp/ui/spinner/Spinner.Apple";
import { ModalImageViewerContext } from 'noood/contexts/contexts';
import { useEscape } from "noood/hooks/useEscape";
export default function ModalImageViewerProvider(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    urls = _useState4[0],
    setUrls = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    currentIndex = _useState6[0],
    setCurrentIndex = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    currentNavDirectionHovered = _useState8[0],
    setCurrentNavDirectionHovered = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    currentImageStyle = _useState0[0],
    setCurrentImageStyle = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    imgIsLoading = _useState10[0],
    setImgIsLoading = _useState10[1];
  var prevButtonRef = /*#__PURE__*/createRef();
  var nextButtonRef = /*#__PURE__*/createRef();
  var __open = function __open(_ref) {
    var urls = _ref.urls,
      idx = _ref.idx;
    setUrls(urls);
    setModalIsOpen(true);
    setCurrentIndex(idx);
  };
  var __close = function __close() {
    setModalIsOpen(false);
    setCurrentIndex(undefined);
    setUrls(undefined);
    setCurrentImageStyle({});
  };
  useEscape(function () {
    __close();
  });
  useEffect(function () {
    // load the image
    if ((urls === null || urls === void 0 ? void 0 : urls.length) > 0 && currentIndex !== void 0) {
      var isMany = urls.length > 1;
      setImgIsLoading(true);
      var viewportWidth = window.innerWidth;
      var isMobile = viewportWidth < 501;
      var availableViewingWidth = viewportWidth - (isMany ? isMobile ? 0 : prevButtonRef.current.getBoundingClientRect().width + nextButtonRef.current.getBoundingClientRect().width + 30 // 15 px allowance from the buttons
      : 0);
      var availableViewingHeight = window.innerHeight;
      var i = new Image();
      i.src = urls[currentIndex];
      i.onerror = function (e) {
        setImgIsLoading(false);
      };
      i.onload = function () {
        setImgIsLoading(false);
        var w = i.width;
        var h = i.height;
        if (w > h) {
          var imageRatio = i.height / i.width;
          w = Math.min(i.width, availableViewingWidth);
          h = Number(math.round(w * imageRatio));
        } else if (w < h) {
          var _imageRatio = i.width / i.height;
          h = Math.min(i.height, availableViewingHeight);
          w = Number(math.round(h * _imageRatio, 2));
        } else if (w == h) {
          h = Math.min(i.width, availableViewingWidth);
          w = h;
        }
        setCurrentImageStyle({
          // transition: `width 0.3s, height 0.3s, margin-top 0.3s, margin-left 0.3s`,
          marginLeft: "-".concat(math.round(w / 2, 2), "px"),
          backgroundImage: "url(".concat(urls[currentIndex], ")"),
          marginTop: "-".concat(math.round(h / 2, 2), "px"),
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "".concat(w, "px auto"),
          top: "50%",
          left: "50%",
          overflow: "hidden",
          width: w,
          height: h
        });

        // preload next/previous image/s
        var nextImage = urls[currentIndex + 1];
        if (nextImage) {
          var nextImg = new Image();
          nextImg.src = nextImage;
          nextImg.onload = function () {
            // console.log(`next image (index: ${currentIndex + 1}) has been pre-loaded.`);
          };
        }
        var prevImageURL = urls[currentIndex - 1];
        if (prevImageURL) {
          var prevImg = new Image();
          prevImg.src = prevImageURL;
          prevImg.onload = function () {
            // console.log(`previous image (index: ${currentIndex - 1}) has been pre-loaded.`);
          };
        }
      };
    }
  }, [currentIndex, urls]);
  return /*#__PURE__*/React.createElement(ModalImageViewerContext.Provider, {
    value: {
      __open: __open
    }
  }, modalIsOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "ModalImageViewerProvider__ui.mask evixxii4 ev13vifvy ev3m8u43 ev1ey2m1c evu96u03 evhtitgo ev1ju8dar"
  }, {
    onClick: function onClick() {
      if (props.closeOnClickMask === void 0 || props.closeOnClickMask) {
        __close();
      }
    }
  })), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.nav_button, ui.prev, currentNavDirectionHovered === 'left' && ui.prev_hovered), {
    onMouseEnter: function onMouseEnter() {
      setCurrentNavDirectionHovered("left");
    },
    onMouseLeave: function onMouseLeave() {
      setCurrentNavDirectionHovered(undefined);
    },
    onClick: function onClick() {
      if (!imgIsLoading) {
        setCurrentIndex(function (prevIdx) {
          return prevIdx - 1 < 0 ? (urls === null || urls === void 0 ? void 0 : urls.length) - 1 : prevIdx - 1;
        });
      }
    },
    ref: prevButtonRef
  }), (urls === null || urls === void 0 ? void 0 : urls.length) > 1 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ModalImageViewerProvider__ui.button ev100vrsf ev1vqgdyp evuz7yzd ev11gdpij ev78zum5 ev6s0dn4 evl56j7k ev1ypdohk"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-left",
    size: 30,
    color: "#333"
  })))), /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "ModalImageViewerProvider__ui.close ev1h2kqdt evixxii4 ev1jzctok ev4a824z ev1w0boku evezl2tj evlrawln evaszc3p ev78zum5 ev6s0dn4 evl56j7k ev1ypdohk"
  }, {
    onClick: function onClick() {
      __close();
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "x",
    size: 25,
    color: "#fefefe"
  })), /*#__PURE__*/React.createElement("div", _extends({}, {
    className: "ModalImageViewerProvider__ui.img evixxii4 ev1nrll8i evwa60dl ev1i1rx1s evjm9jq1 evoegz02"
  }, {
    style: currentImageStyle
  })), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.nav_button, ui.next, currentNavDirectionHovered === 'right' && ui.next_hovered), {
    onMouseEnter: function onMouseEnter() {
      setCurrentNavDirectionHovered('right');
    },
    onMouseLeave: function onMouseLeave() {
      setCurrentNavDirectionHovered(undefined);
    },
    onClick: function onClick() {
      if (!imgIsLoading) {
        setCurrentIndex(function (prevIdx) {
          return prevIdx + 1 > (urls === null || urls === void 0 ? void 0 : urls.length) - 1 ? 0 : prevIdx + 1;
        });
      }
    },
    ref: nextButtonRef
  }), (urls === null || urls === void 0 ? void 0 : urls.length) > 1 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ModalImageViewerProvider__ui.button ev100vrsf ev1vqgdyp evuz7yzd ev11gdpij ev78zum5 ev6s0dn4 evl56j7k ev1ypdohk"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron-right",
    size: 30,
    color: "#333"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "ModalImageViewerProvider__ui.stats evixxii4 evu96u03 ev1wa3icf ev3m8u43 ev1u8a7rm ev14odnwx ev78zum5 ev6s0dn4 evl56j7k"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ModalImageViewerProvider__ui.stats_content evh4b7qa ev1gqu590 evfifm61 evn5hx6u ev1rg5ohu"
  }, currentIndex + 1, " of ", urls === null || urls === void 0 ? void 0 : urls.length)), imgIsLoading && /*#__PURE__*/React.createElement("div", {
    className: "ModalImageViewerProvider__ui.loading ev1nh4oco ev160uoy evixxii4 ev3m8u43 ev1ey2m1c ev14odnwx ev1u8a7rm evfifm61 ev78zum5 ev1nejdyq"
  }, /*#__PURE__*/React.createElement(SpinnerApple, null), /*#__PURE__*/React.createElement("div", null, "Loading..."))), props.children);
}

// @ts-ignore
_inject(".evixxii4{position:fixed}", 3000);
_inject(".ev13vifvy{top:0}", 4000);
_inject(".ev3m8u43{right:0}", 4000);
_inject(".ev1ey2m1c{bottom:0}", 4000);
_inject(".evu96u03{left:0}", 4000);
_inject(".evhtitgo{z-index:2}", 3000);
_inject(".ev1ju8dar{background-color:rgba(0,0,0,.99)}", 3000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1jzctok{top:5px}", 4000);
_inject(".ev4a824z{right:5px}", 4000);
_inject(".ev1w0boku{z-index:6}", 3000);
_inject(".evezl2tj{width:25px}", 4000);
_inject(".evlrawln{height:25px}", 4000);
_inject(".evaszc3p{border-radius:25px}", 2000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev100vrsf{width:40px}", 4000);
_inject(".ev1vqgdyp{height:40px}", 4000);
_inject(".evuz7yzd{border-radius:40px}", 2000);
_inject(".ev11gdpij{background-color:rgba(255,255,255,.8)}", 3000);
_inject(".ev1u8a7rm{z-index:5}", 3000);
_inject(".ev1pju0fl{width:50px}", 4000);
_inject(".evvljbw8{transition:background-color .2s,padding .2s}", 2000);
_inject(".evjbqb8w{background-color:transparent}", 3000);
_inject(".evv0dmp8{transition:padding-left .2s}", 2000);
_inject(".ev1igx7t4{padding-left:15px}", 4000);
_inject(".evcpk43y{padding-left:5px}", 4000);
_inject(".evcj0zz3{transition:padding-right .2s}", 2000);
_inject(".ev172e5tb{padding-right:15px}", 4000);
_inject(".ev1nx2rwh{padding-right:5px}", 4000);
_inject(".ev1nrll8i{left:50%}", 4000);
_inject(".evwa60dl{top:50%}", 4000);
_inject(".ev1i1rx1s{width:1px}", 4000);
_inject(".evjm9jq1{height:1px}", 4000);
_inject(".evoegz02{z-index:4}", 3000);
_inject(".ev1wa3icf{bottom:5px}", 4000);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".evh4b7qa{background-color:rgba(255,255,255,.2)}", 3000);
_inject(".ev1gqu590{padding:3px 10px}", 1000);
_inject(".evfifm61{font-size:12px}", 3000);
_inject(".evn5hx6u{border-radius:15px}", 2000);
_inject(".ev1rg5ohu{display:inline-block}", 3000);
_inject(".ev1nh4oco{background-color:rgba(0,0,0,.2)}", 3000);
_inject(".ev160uoy{color:#aaa}", 3000);
_inject(".ev1nejdyq{gap:5px}", 2000);
var ui = {
  nav_button: {
    "ModalImageViewerProvider__ui.nav_button": "ModalImageViewerProvider__ui.nav_button",
    position: "evixxii4",
    display: "ev78zum5",
    zIndex: "ev1u8a7rm",
    top: "ev13vifvy",
    bottom: "ev1ey2m1c",
    width: "ev1pju0fl",
    alignItems: "ev6s0dn4",
    justifyContent: "evl56j7k",
    transition: "evvljbw8",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    backgroundColor: "evjbqb8w",
    cursor: "ev1ypdohk",
    $$css: true
  },
  prev: {
    "ModalImageViewerProvider__ui.prev": "ModalImageViewerProvider__ui.prev",
    left: "evu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    transition: "evv0dmp8",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    paddingLeft: "ev1igx7t4",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: true
  },
  prev_hovered: {
    "ModalImageViewerProvider__ui.prev_hovered": "ModalImageViewerProvider__ui.prev_hovered",
    paddingLeft: "evcpk43y",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: true
  },
  next: {
    "ModalImageViewerProvider__ui.next": "ModalImageViewerProvider__ui.next",
    transition: "evcj0zz3",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    paddingRight: "ev172e5tb",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    right: "ev3m8u43",
    insetInlineStart: null,
    insetInlineEnd: null,
    $$css: true
  },
  next_hovered: {
    "ModalImageViewerProvider__ui.next_hovered": "ModalImageViewerProvider__ui.next_hovered",
    paddingRight: "ev1nx2rwh",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: true
  }
};
export function useModalImageViewerContext() {
  var context = useContext(ModalImageViewerContext);
  // Error handling if used outside provider
  if (context === undefined) {
    throw new Error('useModalImageViewerContext must be used within a ModalImageViewerProvider');
  }
  return context;
}